var render = function (_h,_vm) {var _c=_vm._c;return _c('span',{staticClass:"next-number",attrs:{"data-level":_vm.props.level,"data-value":_vm.props.value,"data-type":_vm.props.type}})}
var staticRenderFns = []

export { render, staticRenderFns }